import { preact, JSX, $$ } from "../../Core/References";
import { DataControl, IDataControlProps } from "../DataControl/DataControl";


interface ICheckBoxProps extends IDataControlProps
{
    onChange?: preact.JSX.GenericEventHandler<HTMLInputElement>
    size?: string;
    text?: string;
}

export class CheckBox extends DataControl<ICheckBoxProps>
{
    private _chkBox: HTMLInputElement;

    constructor(props: ICheckBoxProps)
    {
        super(props);       
    }

    public setValue(value)
    {
        this._chkBox.checked = !!value;
    }

    public getValue()
    {
        return this._chkBox.checked;
    }

    public focus(): void
    {
        $$.focus(this._chkBox);
    }

    public render(): JSX.Element
    {
        let sizeProps = {} as preact.JSX.CSSProperties;
        if (this.props.size)
        {
            sizeProps.height = this.props.size;
            sizeProps.width = this.props.size;
        }

        return (<span ref={(container) => this._registerContainer(container)}>{this.props.text}
            <input type="checkbox" style={{ verticalAlign: "middle", ...sizeProps }} ref={(chkBox) => this._chkBox = chkBox} onChange={this.props.onChange} />
        </span>);
    };
}
